export default "__VITE_ASSET__uODQJBC5__"